import Modal from 'components/Modal/Modal'
import Reducer from 'components/Modal/reducer'

export default Modal

export { Reducer }
